"use client"

import { Building2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Building2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Building2Icon = component(Icon)({ as: Building2 })
